<template>
    <div class="result-table-wrapper">
        <div class="table-layout" style="width: 100%;">
            <el-table class="result-table" :class="{'single-sel' : rowNoShow && !multiSelect}" ref="result-table" :data="dataRows" :row-class-name="getTableRowClassName" stripe border :row-key="rowKeyPropName" :size="rowSize"
                      :height="theTableHeight" style="width: 100%;" @header-dragend="handleColWidthChg" @current-change="handleClickRow" @row-click="handleClickRow1st" @row-dblclick="handleDblClickRow"
                      @selection-change="handleSelectionChg">
                <!-- 多选头 -->
                <el-table-column v-if="multiSelect && usedColCount >0" label="选择" width="40" align="center" fixed type="selection" :selectable="isRowSelectable"></el-table-column>
                <!-- 行号列 -->
                <el-table-column v-if="rowNoShow && usedColCount >0" label="行号" width="60" align="center" :fixed="rowNoFixedX" type="index" :index="getRowNo"></el-table-column>
                <!-- 数据列 -->
                <template v-for="(group, groupIndex) in groupList">
                    <template v-if="group == ''" v-for="usedCol in groupColLists[groupIndex]">
                        <el-table-column :prop="usedCol.name" :width="parseColWidth(usedCol.width)" :align="usedCol.align" :show-overflow-tooltip="usedCol.overflowAsTip" :fixed="usedCol.fixed">
                            <template slot-scope="scope" slot="header">
                                {{ usedCol.title || usedCol.text }}
                                <span v-if="hasSortInfo(usedCol.name)" :class="getSortClass(usedCol.name)">
                                <span class="caret-wrapper mark-only"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
                                <span style="font-weight: 100;">{{ getSortSeqNo(usedCol.name) }}</span>
                            </span>
                                <el-tooltip v-if="usedCol.tooltip" class="item" effect="dark" placement="top" :open-delay="tooltipDelayMs">
                                    <span slot="content" style="white-space: pre-wrap" v-html="usedCol.tooltip"></span>
                                    <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <swb-html-wrapper :html="makeCellHtml(scope.row[usedCol.name], usedCol.name, scope.$index, scope.row)" :data="makeCellData(scope.row[usedCol.name], usedCol.name, scope.$index, scope.row)"
                                                  :handler="proxyHandler"></swb-html-wrapper>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-if="group != ''">
                        <el-table-column :label="group" align="center">
                            <template v-for="usedCol in groupColLists[groupIndex]">
                                <el-table-column :prop="usedCol.name" :width="parseColWidth(usedCol.width)" :align="usedCol.align" :show-overflow-tooltip="usedCol.overflowAsTip" :fixed="usedCol.fixed">
                                    <template slot-scope="scope" slot="header">
                                        {{ usedCol.title || usedCol.text }}
                                        <span v-if="hasSortInfo(usedCol.name)" :class="getSortClass(usedCol.name)">
                                        <span class="caret-wrapper mark-only"><i class="sort-caret ascending"></i><i class="sort-caret descending"></i></span>
                                        <span style="font-weight: 100;">{{ getSortSeqNo(usedCol.name) }}</span>
                                    </span>
                                        <el-tooltip v-if="usedCol.tooltip" class="item" effect="dark" placement="top" :open-delay="tooltipDelayMs">
                                            <span slot="content" style="white-space: pre-wrap" v-html="usedCol.tooltip"></span>
                                            <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <swb-html-wrapper :html="makeCellHtml(scope.row[usedCol.name], usedCol.name, scope.$index, scope.row)" :data="makeCellData(scope.row[usedCol.name], usedCol.name, scope.$index, scope.row)"
                                                          :handler="proxyHandler"></swb-html-wrapper>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table-column>
                    </template>
                </template>

                <!-- 操作列 -->
                <template v-if="hasBtnCol()  && usedColCount >0">
                    <el-table-column :prop="btnColName" :width="btnColWidth" :align="btnColAlign" :label="btnColTitle" :fixed="btnColFixed ? 'right' : false">
                        <template slot-scope="scope" slot="header">
                            <span>{{ btnColTitle }}</span>
                            <span v-if="custConfEnabled && mountedFlag" class="fr">
                            <el-link @click="showColConfUI($event, 'right-start')" title="调整列的显示设置" size="mini" style="font-size:12px;color:#0c64eb;margin-top: -1px;" icon="el-icon-set-up">设置</el-link>
                        </span>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="btnColMorePossible(getBtnColTplItems(scope.row, scope.$index), btnColBaseCount)">
                                <swb-html-wrapper :html="makeBtnColHtml(getBtnColTplItems(scope.row, scope.$index), btnColBaseCount)" :data="makeCellData(null, btnColName, scope.$index, scope.row)"
                                                  :handler="proxyHandler"></swb-html-wrapper>
                                <swb-ext-dropdown :title="btnColMoreTitle" :items="makeBtnColMoreItems(getBtnColTplItems(scope.row, scope.$index), btnColBaseCount)" :data="makeCellData(null, btnColName, scope.$index, scope.row)"
                                                  :handler="proxyHandler"></swb-ext-dropdown>
                            </span>
                            <span v-else="">
                                <swb-html-wrapper :html="makeBtnColHtml(getBtnColTplItems(scope.row, scope.$index), -1)" :data="makeCellData(null, btnColName, scope.$index, scope.row)" :handler="proxyHandler"></swb-html-wrapper>
                            </span>
                        </template>
                    </el-table-column>
                </template>

            </el-table>
        </div>
        <div v-if="needPager" class="pagination-wrapper" style="padding-top:10px;padding-bottom:8px;overflow: hidden">
            <el-pagination :small="rowSize == 'small'" class="fr" background :pager-count="11" :page-sizes="pageSizes" :page-size="pageSize" :total="totalCount" :current-page="pageNumber" @current-change="handlePageNoChange"
                           @size-change="handlePageSizeChange" layout="prev, pager, next, jumper, slot, total, sizes">
                <span v-if="!hasBtnCol() && custConfEnabled && mountedFlag" class="fr">
                    <el-divider direction="vertical"></el-divider>
                    <el-link @click="showColConfUI($event, 'left-start')" title="调整列的显示设置" size="mini" style="font-size:12px;color:#0c64eb;margin-top: -1px;" icon="el-icon-set-up">设置</el-link>
                </span>
            </el-pagination>
        </div>
        <!-- 结果列设置弹出框 -->
        <swb-dt-popover v-if="custConfEnabled" ref="colConfPopover" placement="right-start" trigger="manual" v-model="colConfUIVisible" @show="syncColConfUIVisible(true)" @hide="syncColConfUIVisible(false)">
            <swb-result-col-conf ref="colConfRef" :forHisQry="forHisQry" :showExtBtns="showConfExtBtns" :custSavable="isCustStorable()" :onConfirm="onColConfConfirm" :onClose="onColConfCancel" :onSaveCustConf="onSaveColConfInfo"
                                 :fixedColAllowed="fixedColAllowed" :metaColList="liveColList" :custColList="custColList"></swb-result-col-conf>
        </swb-dt-popover>
    </div>
</template>

<script>
    // last modified by koqiui
    import {Utils} from '../../app.base'
    import {getDefaultPageSizes} from '../../app.conf'
    import {Vue, MsgBox, getColDefAlign, getColDefFormat, castToJsonArray, getQueryResultConfStorer} from '../../app.vues'
    import {parseEnumMapExpr} from './Cmn'
    import SwbHtmlWrapper from '../ctrl/HtmlWrapper.vue';

    Vue.regist(SwbHtmlWrapper);

    import SwbExtDropdown from '../ctrl/ExtDropdown.vue';

    Vue.regist(SwbExtDropdown);

    import SwbDtPopover from '../ctrl/DtPopover.vue'

    Vue.regist(SwbDtPopover);

    import {extractCustColInfo, reserveMergeColArray, arrangeColList} from './ResultColConf.vue';
    import SwbResultColConf from './ResultColConf.vue';

    Vue.regist(SwbResultColConf);

    //
    function getResultConfStorer() {
        return getQueryResultConfStorer();
    }

    //时间字符串转为Date对象
    function toDateInst(timeOrStr) {
        if (typeof timeOrStr == 'string') {
            timeOrStr = timeOrStr.trim();
            if (timeOrStr.length == 0) {
                return null;
            }
            if (timeOrStr.indexOf(' ') == -1 && timeOrStr.indexOf(':') != -1) {
                //纯时间，不包含日期（加上日期部分）
                let todayStr = new Date().format('yyyy-MM-dd');
                timeOrStr = todayStr + ' ' + timeOrStr;
            }
        }
        return Date.parseAsDate(timeOrStr);
    }

    /** 格式化日期/时间 */
    function formatDateX(date, format) {
        if (!date) {
            return '';
        }
        format = format || 'yyyy-MM-dd HH:mm:ss';
        let dateObj = toDateInst(date);
        return Date.isValidDate(dateObj) ? dateObj.format(format) : (date + '');
    }

    let parseNumFormat = Utils.parseNumFormat;
    let formatNum = Utils.formatNum;
    let formatBool = Utils.formatBool;
    //默认浮点数格式化
    let default_float_format = parseNumFormat('0.00');
    //默认百分比格式化
    let default_percent_format = parseNumFormat('0%');
    //最大列宽像素数
    const MAX_COL_WIDTH = 600;

    //操作列默认基础函数个数
    const BTN_COL_BASE_COUNT = 4;

    //能否渲染出下列菜单
    function btnColMorePossible(btnItems, btnColBaseCount) {
        btnItems = btnItems || [];
        btnColBaseCount = btnColBaseCount || BTN_COL_BASE_COUNT;
        if (typeof btnItems == 'string') {
            return false;
        }
        if (btnItems.length <= btnColBaseCount) {
            return false;
        }
        for (let i = btnColBaseCount, c = btnItems.length; i < c; i++) {
            let btnItem = btnItems[i];
            if (!btnItem.name) {// {name, text }
                return false;
            }
        }
        return true;
    }

    const btnIconHtmlTpl = '<i class="{0}" style="margin-right: 4px;"></i>';
    const btnItemHtmlTpl = '<button class="swb-btn swb-btn-link" name="{name}">{iconHtml}{text}</button>';
    const btnItemHtmlTplDisabled = '<button class="action-btn swb-btn swb-btn-mini disabled" disabled name="{name}">{iconHtml}{text}</button>';
    const btnItemHtmlTplImaged = '<button class="action-btn swb-btn swb-btn-mini" name="{name}" title="{text}"><img src="{image}" class="action-img" /></button>';
    const btnItemHtmlTplImagedDisabled = '<button class="action-btn swb-btn swb-btn-mini disabled" disabled name="{name}" title="{text}"><img src="{image}" disabled class="action-img" /></button>';

    //
    function makeBtnColHtml(btnItems, btnColBaseCount) {
        btnColBaseCount = btnColBaseCount || BTN_COL_BASE_COUNT;
        btnItems = btnItems || [];
        if (typeof btnItems == 'string') {
            return btnItems;
        }
        //
        let btnHtmls = '';
        let count = btnColBaseCount < 0 ? btnItems.length : Math.min(btnItems.length, btnColBaseCount);
        for (let i = 0; i < count; i++) {
            let btnItem = btnItems[i];
            if (typeof btnItem == 'string') {
                btnHtmls += Utils.appendStrFor(i, '&nbsp;&nbsp;', btnItem);
            } else {
                let itemHtml = '';
                let itemHtmlTpl = '';
                if (btnItem.image) {
                    itemHtmlTpl = btnItem.disabled ? btnItemHtmlTplImagedDisabled : btnItemHtmlTplImaged;
                    itemHtml = itemHtmlTpl.format({
                        name: btnItem.name,
                        text: btnItem.text || btnItem.name,
                        image: btnItem.image || ''
                    });
                } else {
                    itemHtmlTpl = btnItem.disabled ? btnItemHtmlTplDisabled : btnItemHtmlTpl
                    itemHtml = itemHtmlTpl.format({
                        name: btnItem.name,
                        text: btnItem.text || btnItem.name,
                        iconHtml: btnItem.icon ? btnIconHtmlTpl.format(btnItem.icon) : ''
                    });
                }
                btnHtmls += Utils.appendStrFor(i, '&nbsp;&nbsp;', itemHtml);
            }
        }
        return btnHtmls;
    }

    function makeBtnColMoreItems(btnItems, btnColBaseCount) {
        btnColBaseCount = btnColBaseCount || BTN_COL_BASE_COUNT;
        btnItems = btnItems || [];
        if (typeof btnItems == 'string' || btnItems.length <= btnColBaseCount) {
            return [];
        }
        return btnItems.slice(btnColBaseCount);
    }

    //默认渲染函数
    function returnValue(row, colName, colValue, rowIndex, colConf) {
        if (colConf != null) {
            let dataType = colConf['dataType'];
            let format = colConf['formatMeta'] || colConf['format'];
            if (dataType == 'float') {
                format = format || default_float_format;
                return formatNum(colValue, format);
            } else if (dataType == 'integer') {
                let enumMapObject = colConf['enumMapObject'] || null;
                if (enumMapObject) {
                    return enumMapObject[colValue + ''];
                } else {
                    return formatNum(colValue, format);
                }
            } else if (dataType == 'date') {
                if (format) {
                    return formatDateX(colValue, format);
                }
            } else if (dataType == 'bool') {
                if (format) {
                    return formatBool(colValue, format);
                }
            }
        }
        return colValue == null ? '' : colValue;
    }

    function renderLinkCell(row, colName, colValue, rowIndex, colConf) {
        let retValue = returnValue(row, colName, colValue, rowIndex, colConf);
        if (colConf != null) {
            let dataType = colConf['dataType'];
            if (dataType == 'float' || dataType == 'integer') {
                if (colValue == 0 && colConf['linkFuncIgnore0']) {
                    return retValue;
                }
            }
        }
        return '<a href="#" name="' + colName + '" style="color:#409EFF;">' + retValue + '</a>';
    }

    //默认按钮点解函数处理器
    function consoleFunc(row, colName, colValue, rowIndex, btnName) {
        console.debug((btnName || colName) + ' clicked');
        console.debug({row, colName, colValue, rowIndex});
    }

    //
    function mergeSelection(selectionMap, allRows = [], selRows = [], keyColName = 'id') {
        let allKeyVals = allRows.pluck(keyColName);
        let selKeyVals = selRows.pluck(keyColName);
        let delKeyVals = allKeyVals.filter(function (value) {
            return selKeyVals.indexOf(value) == -1;
        });
        //console.debug('----- delKeyVals -----');
        //console.debug(delKeyVals);
        //删除
        for (let i = 0, c = delKeyVals.length; i < c; i++) {
            let val = delKeyVals[i];
            delete selectionMap[val + ''];
        }
        //添加
        for (let i = 0, c = selRows.length; i < c; i++) {
            let row = selRows[i];
            let val = row[keyColName];
            selectionMap[val + ''] = row;
        }
    }

    function findAndUpdateSelection(selectionMap, allRows = [], keyColName = 'id') {
        let selection = [];
        for (let i = 0, c = allRows.length; i < c; i++) {
            let row = allRows[i];
            let val = row[keyColName];
            let rowOld = selectionMap[val + ''];
            if (typeof rowOld != 'undefined') {
                selection.push(row);
                //更新为最新的
                selectionMap[val + ''] = row;
            }
        }
        return selection;
    }

    /** 生成渲染分组数据 */
    function makeGroupMeta(usedColList = []) {
        let groupList = [];//分组标题
        let groupColLists = [];
        let prevGroup = null;
        let tempCol = null;
        let tempGroup = null;
        let tempGroupCols = null;
        for (let i = 0, c = usedColList.length; i < c; i++) {
            tempCol = usedColList[i];
            tempGroup = tempCol.group || '';
            if (tempGroup != prevGroup) {
                groupList.push(tempGroup);
                tempGroupCols = [];
                groupColLists.push(tempGroupCols);
                //
                prevGroup = tempGroup;
            }
            tempGroupCols.push(tempCol);
        }
        return {
            groupList: groupList,
            groupColLists: groupColLists
        };
    }

    /** 比较列头信息是否变动了 */
    function isColHeadUpdated(groupListOld, groupColListsOld, groupListNew, groupColListsNew) {
        groupListOld = groupListOld || [];
        groupColListsOld = groupColListsOld || [];
        //
        if (groupListOld.length != groupListNew.length) {
            return true;
        }
        for (let i = 0, ic = groupListOld.length; i < ic; i++) {
            let groupOld = groupListOld[i];
            let groupNew = groupListNew[i];
            if (groupOld != groupNew) {
                return true;
            }
            let colListOld = groupColListsOld[i];
            let colListNew = groupColListsNew[i];
            if (colListOld.length != colListNew.length) {
                return true;
            }
            for (let j = 0, jc = colListOld.length; j < jc; j++) {
                let colConfOld = colListOld[j];
                let colConfNew = colListNew[j];
                if (colConfOld.name != colConfNew.name) {//列名
                    return true;
                }
                if (colConfOld.asTpl != colConfNew.asTpl) {//模板化
                    return true;
                }
                let titleOld = colConfOld.title || colConfOld.text;
                let titleNew = colConfNew.title || colConfNew.text;
                if (titleOld != titleNew) {//列标题
                    return true;
                }
                if (colConfOld.tooltip != colConfNew.tooltip) {//提示
                    return true;
                }
            }
        }
        return false;
    }

    function isColSortUpdated(sortItemListOld, sortItemListNew) {
        sortItemListOld = sortItemListOld || [];
        if (sortItemListOld.length != sortItemListNew.length) {
            return true;
        }
        for (let i = 0, c = sortItemListOld.length; i < c; i++) {
            if (sortItemListOld[i] != sortItemListNew[i]) {
                return true;
            }
        }
        return false;
    }

    function parseLinkFuncName(linkFuncExpr) {
        if (linkFuncExpr) {
            linkFuncExpr = linkFuncExpr.trim();
            if (linkFuncExpr == '') {
                return null;
            }
            let index = linkFuncExpr.indexOf('(');
            let funcName = linkFuncExpr;
            if (index != -1) {
                funcName = linkFuncExpr.substring(0, index);
                funcName = funcName.trim();
            }
            return funcName == '' ? null : funcName;
        }
        return null;
    }

    let TaskDelayer = Utils.TaskDelayer;
    let CondMonitor = Utils.CondMonitor;
    let pagerFixedHeight = 50;
    //
    const default_fixedColAllowed = 3;
    //
    export default {
        name: 'swb-result-table',
        desc: '普通结果表格（只按html渲染）',
        //
        props: {
            forHisQry: {//是否历史查询模式
                type: Boolean,
                default: false
            },
            confKey: {//自定义配置加载/保存key
                type: String
            },
            custConfEnabled: {//是否支持自定义调整
                type: Boolean,
                default: true
            },
            //----------------------------------
            //结果元设信息
            config: null,
            /*{
             type: Object,
             default: {
             //允许的固定列数量
             fixedColAllowed: default_fixedColAllowed,
             //结果列配置
             colList: []
             }
             }*/
            configAuto: {//是否根据confKey自动获取元数据配置
                type: Boolean,
                default: false
            },
            onConfigReady: {//配置加载完成回调函数
                type: Function,
                default: null
            },
            //
            needPager: {//是否需要分页组件
                type: Boolean,
                default: true
            },
            pageSizeList: {//分页大小列表
                type: Array,
                default: null
            },
            //
            multiSelect: {//是否支持多选
                type: Boolean,
                default: false
            },
            rowKeyPropName: {//记录数据关键标识列名（多页/跨页选择必须，默认: id）
                type: String,
                default: 'id'
            },
            multiPageSelect: {//是否要多页/跨页选择
                type: Boolean,
                default: false
            },
            rowNoShow: {//是否显示行号
                type: Boolean,
                default: false
            },
            rowNoFixed: {//行号列是否固定
                type: Boolean,
                default: false
            },
            rowNoAsSeqNo: {//行号即是顺序号（多页连续）
                type: Boolean,
                default: true
            },
            rowSize: {//mini,small
                type: String,
                default: 'small'
            },
            //操作列
            btnColName: {//操作列名称（若为空则不显示操作列）
                type: String,
                default: null
            },
            btnColWidth: {//操作列宽度
                type: Number,
                default: 100
            },
            btnColTitle: {//操作列标题
                type: String,
                default: '操作'
            },
            btnColFixed: {//操作列是否固定
                type: Boolean,
                default: false
            },
            btnColAlign: {//操作列水平对齐 left, center, right
                type: String,
                default: 'left'
            },
            btnColBaseCount: {//操作列基础显示按钮数量
                type: Number,
                default: BTN_COL_BASE_COUNT
            },
            btnColMoreTitle: {//操作列更多显示标题
                type: String,
                default: '更多操作'
            },
            //
            height: {
                default: '100%'
            },
            minColWidth: {//最小列宽像素数（小于此像素数则改为自动列宽）
                type: Number,
                default: 60
            },
            //
            pageNoChangeHandler: {//分页页码变更处理函数(pageNo, pageSize)
                type: Function,
                default: null
            },
            //
            rowDblClickHandler: {//单选时行被双击的回调处理函数(row)
                type: Function,
                default: null
            },
            //
            selChangeHandler: {//选择变更时回调处理函数(multiSelect, clicks)
                type: Function,
                default: null
            },
            //
            colWidthChangeHandler: {//列宽度变化监听函数(colName, colWidth)
                type: Function,
                default: null
            }
        },
        //
        watch: {
            confKey(newVal, oldVal) {
                this.custInfoLoadState = 0;
                //
                if (this.configAuto) {
                    this.autoLoadConf(true);
                } else {
                    this.prepare();
                }
            },
            config: {
                handler(newVal, oldVal) {
                    this.custInfoLoadState = 0;
                    //
                    this.prepare();
                }
            },
            needPager(newVal, oldVal) {
                this.render(this.getCurData(false));
            },
            multiSelect(newVal, oldVal) {
                if (!this.multiSelect) {
                    this.multiPageSelect = false;
                }
                this.clearSelection();
                //
                this.initChecked = null;
                this.initCheckedSet = {};
                //
                this.render(this.getCurData(false));
            },
            multiPageSelect(newVal, oldVal) {
                this.clearSelection();
                //
                this.initChecked = null;
                this.initCheckedSet = {};
                //
                this.render(this.getCurData(false));
            },
            rowNoShow(newVal, oldVal) {
                this.render(this.getCurData(true));
            },
            rowNoFixed(newVal, oldVal) {
                this.rowNoFixedX = this.rowNoFixed;
                this.render(this.getCurData(true));
            },
            rowNoAsSeqNo(newVal, oldVal) {
                this.render(this.getCurData(true));
            },
            btnColName(newVal, oldVal) {
                this.render(this.getCurData(true));
            },
            height(newVal, oldVal) {
                this.setHeights();
            },
            minColWidth(newVal, oldVal) {
                this.render(this.getCurData(true));
            }
        },
        //
        data() {
            return {
                mountedFlag: false,
                //
                theElTable: null,
                theElTableWrapper: null,
                theTableHeight: '100%',
                tooltipDelayMs: 200,
                //
                linkFuncContext: null,//链接函数调用上下文this
                //初始选中项
                initChecked: null,
                //设置的初始选中项(key.value => true，仅多选有效)
                initCheckedSet: null,
                //行禁用(row)
                rowDisabler: null,
                //初始选中项是否禁用
                initCheckedDisabled: false,
                //跨页选择缓存map
                mulSelectionMap: {},
                ignoreSelectionChange: false,//恢复标记
                //当页选择
                curSelection: null,
                //ResultColConf.vue 实例对象的引用
                colConfRef: null,
                //结果列配置信息分项
                showConfExtBtns: true,
                colConfUIVisible: false,
                //QuerySortArea.vue 实例对象的引用
                //会自动获取其中的ResultColConf.vue 实例对象的引用
                qrySortRef: null,
                //config
                fixedColAllowed: default_fixedColAllowed,
                metaColList: [],
                //
                custColList: [],
                //自定义信息是加载状态：0 未开始，1 加载中, 2 加载完毕
                custInfoLoadState: 0,
                //
                liveColList: [],
                //
                rowNoFixedX: false,
                //所有列信息
                fullColMap: {},
                //
                usedColMap: {},//
                usedColCount: 0,
                usedColList: [],
                groupList: [],
                groupColLists: [],
                //报表专用支持
                reportCode: null,
                //导出专用
                exportRowNo: false,
                exportRowNoColName: 'row_no',
                exportRowNoColTitle: '行号',
                //
                linkFuncMap: {},//
                renderFuncs: {},
                //操作按钮列模板
                btnColTplItemsMap: {},
                //
                handlerFuncs: {},
                defaultFunc: null,
                //条件信息
                curQryItems: [],
                //排序信息
                sortItemList: [], //排序原始信息
                sortItemChanged: false, //排序信息是否变更
                sortItemMap: {},
                //
                dataRows: [],
                //
                //分页处理
                pageSizes: getDefaultPageSizes(),
                pageSize: 10,

                totalCount: 0,
                pageNumber: 1
            };
        },
        //
        created() {
            let self = this;
            //
            this.linkFuncHandler = function (row, colName, colValue, rowIndex, btnName) {
                let linkFuncName = self.linkFuncMap[colName];
                let context = self.linkFuncContext || window;
                let reportCode = self.reportCode || null;
                let destFunc = context[linkFuncName];
                if (typeof destFunc == 'function') {
                    destFunc(row, reportCode, colName);
                } else {
                    console.error('函数未定义：' + linkFuncName);
                }
            };
            //
            let func = function (row, colName, colValue, rowIndex, btnName, evnt) {
                try {
                    let custHandler = this.getHandlerFunc(colName);
                    custHandler.call(null, row, colName, colValue, rowIndex, btnName, evnt);
                } catch (ex) {
                    console.error(ex);
                }
            };
            //
            this.proxyHandler = function (btnName, data, srcElement, evnt) {
                let row = data.row;
                let colName = data.colName;
                let colValue = data.colValue;
                let rowIndex = data.rowIndex;
                func.call(self, row, colName, colValue, rowIndex, btnName, evnt);
            };
            //
            this.pageEventDelayer = new TaskDelayer();
            //
            let pageSizeList = this.pageSizeList;
            if (pageSizeList != null && pageSizeList.length > 0) {
                this.pageSizes = pageSizeList;
            }
            //
            this.pageSize = this.pageSizes[0];
            //
            this.rowNoFixedX = this.rowNoFixed;
            //--------------------------------------------------------------
            if (this.configAuto) {
                this.autoLoadConf();
            } else {
                this.prepare();
            }
        },
        mounted() {
            this.theElTable = this.$refs['result-table'];
            this.theElTableWrapper = this.theElTable.$el.parentNode;
            this.colConfRef = this.$refs['colConfRef'];
            //
            this.mountedFlag = true;
            //
            this.setHeights();
            //
            if (this.custInfoLoadState == 0) {
                this.render([], null, true);
            }
        },
        beforeDestroy() {
            this.rowDisabler = null;
            if (this.pageEventDelayer != null) {
                this.pageEventDelayer.cancel();
                this.pageEventDelayer = null;
            }
            this.theElTable = null;
            this.theElTableWrapper = null;
            this.colConfRef = null;
            this.linkFuncContext = null;
            this.qrySortRef = null;
            this.linkFuncHandler = null;
            this.proxyHandler = null;
        },
        //
        methods: {
            btnColMorePossible: btnColMorePossible,
            makeBtnColHtml: makeBtnColHtml,
            makeBtnColMoreItems: makeBtnColMoreItems,
            //
            isCustStorable() {//自定义是否可以保存
                return this.custConfEnabled && this.confKey != null;
            },
            autoLoadConf(refreshMeta = false) {
                if (this.config == null || refreshMeta) {
                    if (this.$confStorer == null) {
                        console.error('$confStorer未配置，无法自动获取元数据配置');
                    } else {
                        let self = this;
                        this.$confStorer.loadMetaResultConf(this.confKey, function (success, metaConf) {
                            if (success) {
                                console.debug('自动获取结果元数据配置成功');
                                self.prepare(metaConf);
                            } else {
                                console.error('自动获取元数据配置失败：' + metaConf);
                            }
                        });
                    }
                }
            },
            loadCustInfo(thenCallback) {
                if (this.custInfoLoadState == 0) {//加载自定义配置信息
                    this.custInfoLoadState = 1;
                    if (this.isCustStorable()) {
                        //获取自定义信息
                        let custStorer = getResultConfStorer();
                        if (custStorer == null) {
                            this.custColList = [];
                            this.custInfoLoadState = 2;
                            console.error('自定义信息配置访问器未设置');
                            //
                            thenCallback();
                        } else {
                            let self = this;
                            custStorer.loadCustResultConf(this.confKey, function (success, config) {
                                self.custInfoLoadState = 2;
                                //
                                if (success) {
                                    config = config || {};
                                    //
                                    self.custColList = castToJsonArray(config.colList);
                                    console.debug('---- 上次的自定义结果配置（key : ' + self.confKey + '）----');
                                    console.debug(self.custColList);
                                } else {
                                    self.custColList = [];
                                    //
                                    self.$message({
                                        type: 'warning',
                                        message: config
                                    });
                                }
                                //
                                thenCallback();
                            });
                        }
                    } else {
                        this.custColList = [];
                        this.custInfoLoadState = 2;
                        //
                        thenCallback();
                    }
                }
            },
            prepare(config) {
                config = config || this.config || null;
                //从元数据配置提取动态标签字段信息
                let tagMetaRoleTableList = [];
                let dynaTagFieldsMap = {}; //动态标签字段名 => 字段信息缓存

                let self = this;

                if (config != null) {
                    this.fixedColAllowed = config.fixedColAllowed || default_fixedColAllowed;
                    //
                    console.debug('---- 平台预设的元结果配置（code : ' + config.code + '）----');
                    //
                    let colList = castToJsonArray(config.colList || config.metaCols);
                    //
                    this.metaColList = colList;
                    console.debug(this.metaColList);

                    //
                    let uniqueMap = {}; //防重临时缓存
                    for (let i = 0, c = colList.length; i < c; i++) {
                        let tmpItem = colList[i];
                        if (tmpItem.dynaTag) {
                            dynaTagFieldsMap[tmpItem.name] = tmpItem;
                            //防重临时键
                            let tmpKey = tmpItem.tagMetaRole + ':' + tmpItem.tagMetaTableName;
                            if (uniqueMap[tmpKey] == null) {
                                uniqueMap[tmpKey] = 1;
                                tagMetaRoleTableList.push({
                                    tagMetaRole: tmpItem.tagMetaRole,
                                    tagMetaTableName: tmpItem.tagMetaTableName
                                });
                            }
                        }
                    }
                }

                //融合配置并初始化
                function mergeConfAndInit() {
                    let metaColList = self.metaColList;
                    metaColList.forEach(function (item) {
                        item.metaTitle = item.title || item.text;
                        item.metaGroup = item.group || '';
                    });
                    //console.log(metaColList);

                    self.liveColList = reserveMergeColArray(self.custColList, self.metaColList, 'name');
                    self.liveColList = arrangeColList(self.liveColList);
                    //补全自定义信息
                    self.custColList = self.liveColList.map(function (colConf) {
                        return extractCustColInfo(colConf);
                    });
                    //
                    if (self.onConfigReady) {
                        self.onConfigReady();
                    } else {
                        console.debug('结果配置加载完毕');
                    }
                    //
                    self.render(self.getCurData(true, self.initChecked), null, true);
                }

                //
                if (tagMetaRoleTableList.length > 0) {
                    if (this.$confStorer != null) {
                        this.$confStorer.loadCustTagMetaFields(tagMetaRoleTableList, function (success, tagMetaFields) {
                            // console.log(tagMetaFields);
                            //
                            let namesToDel = []; //要删除的名称
                            for (let name in dynaTagFieldsMap) {
                                let metaField = dynaTagFieldsMap[name];
                                let tagField = tagMetaFields.find(function (tagMeta, index) {
                                    return tagMeta.tagMetaRole == metaField.tagMetaRole && tagMeta.tableName == metaField.tagMetaTableName && tagMeta.fieldName == metaField.name;
                                });
                                if (tagField != null) {
                                    if (tagField.enabled) {
                                        //动态列标题
                                        metaField.text = tagField.dispName;
                                        let itemList = tagField.itemList || [];
                                        let enumMapObject = {};
                                        itemList.forEach(function (item) {
                                            enumMapObject[item.id + ''] = item.name;
                                        });
                                        // 自动枚举映射
                                        metaField.enumMapObject = enumMapObject;
                                    } else {
                                        namesToDel.push(name);
                                    }
                                } else {
                                    namesToDel.push(name);
                                }
                            }
                            //
                            if (namesToDel.length > 0) {
                                //console.log('需要删除的：', namesToDel);
                                let colList = self.metaColList;
                                for (let i = colList.length - 1; i >= 0; i--) {
                                    let tmpItem = colList[i];
                                    if (namesToDel.indexOf(tmpItem.name) != -1) {
                                        colList.removeAt(i);
                                        //console.log('已删除列：' + tmpItem.name);
                                    }
                                }
                            }
                            //
                            self.loadCustInfo(mergeConfAndInit);
                        });
                    } else {
                        console.error('$confStorer未配置，无法自定义标签配置');
                        //
                        this.loadCustInfo(mergeConfAndInit);
                    }

                } else {
                    this.loadCustInfo(mergeConfAndInit);
                }
            },
            //----------------------------------------------
            //融合并刷新自定义配置
            setHeights() {
                if (this.height) {//计算表格高度
                    let isNumHeight = true;
                    if (typeof this.height == 'string') {
                        this.theTableHeight = this.height;
                        isNumHeight = false;
                    } else {
                        let totalHeight = parseInt(this.height);
                        if (totalHeight > 0) {
                            let extraFixedHeight = 8;
                            extraFixedHeight += this.needPager ? pagerFixedHeight : 0;
                            this.theTableHeight = totalHeight - extraFixedHeight;
                        }
                    }
                    //
                    if (this.theElTable != null) {
                        this.$nextTick(function () {
                            this.theElTableWrapper.style.height = isNumHeight ? this.theTableHeight + 'px' : this.theTableHeight;
                            this.theElTable.doLayout();
                        });
                    }
                }
            },
            hasBtnCol() {
                return this.btnColName != null && this.btnColName != '';
            },
            parseColWidth(colWidth) {
                return (colWidth == null || colWidth < this.minColWidth || colWidth > MAX_COL_WIDTH) ? 'fit' : colWidth;
            },
            isRowSelected(row) {
                if (this.multiSelect) {
                    return this.curSelection.indexOf(row) != -1;
                } else {
                    return this.curSelection == row;
                }
            },
            getTableRowClassName({row, rowIndex}) {
                let classNames = '';
                if (this.isRowSelected(row)) {
                    classNames += 'selected';
                }
                if (!this.isRowSelectable(row)) {
                    classNames += ' unselectable';
                }
                return classNames;
            },
            isRowSelectable(row) {
                if (this.multiSelect) {
                    if (this.initCheckedDisabled) {
                        let keyVal = row[this.rowKeyPropName];
                        if (this.initCheckedSet[keyVal + '']) {
                            return false;
                        }
                    }
                } else {
                    if (row['unselectable'] === true) {
                        return false;
                    }
                }
                //检查特定被禁用的
                if (this.rowDisabler != null) {
                    if (this.rowDisabler(row) === true) {
                        return false;
                    }
                }

                return true;
            },
            getRowNo(rowIndex) {
                let baseCount = 0;
                if (this.needPager && this.rowNoAsSeqNo) {
                    baseCount = (this.pageNumber - 1) * this.pageSize;
                }
                return baseCount + rowIndex + 1;
            },
            getCurData(saveSel = false, initChecked) {//是否缓存当前选中数据
                if (saveSel) {//缓存当前选中数据
                    this.initChecked = initChecked || this.getSelection(true);
                }
                //
                return {
                    rows: this.dataRows,
                    pagination: {
                        totalCount: this.totalCount,
                        pageNumber: this.pageNumber
                    }
                };
            },
            init() {
                this.ignoreSelectionChange = true;
                //
                let minColWidth = this.minColWidth;
                //同步最小列宽
                if (this.colConfRef != null) {
                    this.colConfRef.setMinColWidth(minColWidth);
                }
                //
                let hasFixedCols = false;//检查是否有固定列
                let linkFuncMap = {};
                //
                let fullColMap = {};//全部列
                let usedColList = Utils.merge([], this.liveColList);
                usedColList = usedColList.filter(function (column) {
                    fullColMap[column.name] = column;
                    //
                    column.title = (column.title || column.metaTitle).trim();
                    column.group = (column.group || column.metaGroup).trim();
                    //
                    if (column.secret) {//私密字段强制隐藏
                        column.hidden = true;
                    }
                    if (column.hidden) {
                        column.fixed = false;
                        column.title = null;
                        column.group = null;
                    }
                    if (column.fixed) {
                        column.group = null;
                    }
                    column.overflowAsTip = column.overflowAsTip || false;
                    column.align = column.align || getColDefAlign(column);
                    column.format = column.format || getColDefFormat(column);
                    column.asTpl = column.asTpl || false;
                    //处理列宽
                    let tmpWidth = Utils.ParseInt(column.width);
                    if (tmpWidth != null && (tmpWidth < minColWidth || tmpWidth > MAX_COL_WIDTH)) {
                        tmpWidth = null;
                    }
                    column.width = tmpWidth;
                    //
                    let linkFuncName = parseLinkFuncName(column.linkFuncExpr);
                    if (linkFuncName) {
                        //console.info(column.name + " => " + linkFuncName);
                        linkFuncMap[column.name] = linkFuncName;
                    }
                    let visible = !column.hidden;
                    if (visible) {
                        hasFixedCols = hasFixedCols || column.fixed;
                        //预处理数值格式化元数据信息
                        let dataType = column.dataType;
                        if (dataType == 'integer' || dataType == 'float') {
                            let format = column.format;
                            if (format) {//格式处理
                                column.formatMeta = parseNumFormat(format, true);
                            } else {//预先处理枚举设置
                                if (dataType == 'integer') {
                                    var enumMap = column.enumMap || '';
                                    if (enumMap) {
                                        let enumParams = parseEnumMapExpr(enumMap);
                                        if (enumParams) {
                                            column.enumMapObject = getEnumMap(enumParams.name, enumParams.type) || {};
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return visible;
                });
                //
                if (this.rowNoShow && hasFixedCols) {//fix有固定列时，直接设置为true（否则行号不会显示）
                    this.rowNoFixedX = true;
                } else {
                    this.rowNoFixedX = this.rowNoFixed;
                }
                //
                this.btnColTplItemsMap = {};
                this.fullColMap = fullColMap;
                this.usedColMap = usedColList.toMap('name');
                this.linkFuncMap = linkFuncMap;
                //
                let {groupList, groupColLists} = makeGroupMeta(usedColList);
//                for(let i = 0, c = groupList.length; i < c; i++) {
//                    console.group('---[' + groupList[i] + ']---');
//                    console.debug(groupColLists[i]);
//                    console.groupEnd();
//                }
                //
                if (isColHeadUpdated(this.groupList, this.groupColLists, groupList, groupColLists) || this.sortItemChanged) {
                    console.info('列头/排序/提示信息发生变更');
                    //重置列头信息
                    this.usedColCount = 0;
                    this.groupColLists = [];
                    this.groupList = [];
                }
                //
                this.usedColList = usedColList;
                this.$nextTick(function () {
                    this.usedColCount = usedColList.length;
                    this.groupColLists = groupColLists;
                    this.groupList = groupList;
                    this.sortItemChanged = false;
                });
            },
            //--------------- 结果列配置 --------------
            getColConfRefPopover() {
                return this.$refs['colConfPopover'] || null;
            },
            showColConfUI(event, placement) {
                let curBtn = event.currentTarget;
                //
                placement = placement || 'right-start';
                let colConfPopover = this.getColConfRefPopover();
                colConfPopover.bindToReferer(
                    curBtn, 'click', {
                        placement: placement
                    }
                );
                //
                this.colConfUIVisible = !this.colConfUIVisible;
            },
            syncColConfUIVisible(visible) {
                this.colConfUIVisible = visible;
                //
                if (visible) {
                    let colConfPopover = this.getColConfRefPopover();
                    this.$nextTick(function () {
                        let metaColListMaxHeight = $(window).height() - 40;
                        this.colConfRef.setMaxHeight(metaColListMaxHeight);
                        this.$nextTick(function () {
                            colConfPopover.update();
                        });
                    });
                }
            },
            onColConfConfirm() {
                this.colConfUIVisible = false;
                //
                this.liveColList = this.colConfRef.getMetaColList();
                this.custColList = this.colConfRef.getCustColList();
                //
                this.render(this.getCurData(true));
            },
            onColConfCancel() {
                this.colConfUIVisible = false;
                //
                this.$nextTick(function () {
                    this.liveColList = Utils.merge([], this.liveColList);
                    this.custColList = Utils.merge([], this.custColList);
                });
            },
            onSaveColConfInfo() {
                let custColList = this.colConfRef.getCustColList();
                console.debug('----- 保存 ----');
                let custStorer = getResultConfStorer();
                if (custStorer == null) {
                    console.error('自定义信息配置访问器未设置');
                } else {
                    let custConf = {
                        colList: JSON.encode(custColList)
                    };
                    //
                    let self = this;
                    custStorer.saveCustResultConf(this.confKey, custConf, function (success, message) {
                        self.$message({
                            type: success ? 'success' : 'warning',
                            message: message
                        });
                    });
                }
            },
            //----------------------------------------------------------
            hasSortInfo(colName) {
                return this.sortItemMap[colName] != null;
            },
            getSortSeqNo(colName) {
                let sortInfo = this.sortItemMap[colName];
                return sortInfo.seqNo;
            },
            getSortClass(colName) {
                let sortInfo = this.sortItemMap[colName];
                return sortInfo.order == 'desc' ? 'descending' : 'ascending';
            },
            //获取指定列的渲染函数
            getRenderFunc(colName) {
                let realFunc = this.renderFuncs[colName];
                if (realFunc == null) {
                    let linkFuncName = this.linkFuncMap[colName];
                    if (linkFuncName) {
                        realFunc = renderLinkCell;
                    }
                }
                return realFunc == null ? returnValue : realFunc;
            },
            getHandlerFunc(colName) {
                let realFunc = this.handlerFuncs[colName];
                if (realFunc == null) {
                    let linkFuncName = this.linkFuncMap[colName];
                    if (linkFuncName) {
                        realFunc = this.linkFuncHandler;
                    }
                    if (realFunc == null) {//通配处理函数
                        realFunc = this.handlerFuncs['*'];
                    }
                }
                //
                return realFunc || consoleFunc;
            },
            makeCellData(colValue, colName, rowIndex, row) {
                let colConf = this.usedColMap[colName] || null;
                return {
                    row: row,
                    colName: colName,
                    colValue: colValue,
                    rowIndex: rowIndex,
                    colConf: colConf
                };
            },
            getBtnColTplItems(row, rowIndex) {
                if (this.hasBtnCol()) {
                    let btnsColTpl = this.btnColTplItemsMap['row-' + rowIndex];
                    if (btnsColTpl == null) {
                        let btnColName = this.btnColName;
                        let renderFunc = this.getRenderFunc(btnColName);
                        if (typeof renderFunc == 'string' || Utils.isArray(renderFunc)) {//模板字符串
                            btnsColTpl = renderFunc;
                        } else {
                            if (typeof renderFunc == 'function') {
                                btnsColTpl = renderFunc(row, btnColName, null, rowIndex) || null;
                            }
                            if (btnsColTpl != null && !(typeof btnsColTpl == 'string') && !Utils.isArray(btnsColTpl)) {
                                throw '操作列渲染函数返回值无效（只能是html字符串或数组）！';
                            }
                        }
                        //
                        if (!btnsColTpl) {
                            //无效当空
                            btnsColTpl = [];
                        }
                        //
                        this.btnColTplItemsMap['row-' + rowIndex] = btnsColTpl;
                    }
                    return btnsColTpl;
                } else {
                    return null;
                }
            },

            //渲染html
            makeCellHtml(colValue, colName, rowIndex, row) {
                let cellTpl = null;
                let renderFunc = this.getRenderFunc(colName);
                if (typeof renderFunc == 'string') {//模板字符串
                    cellTpl = renderFunc;
                } else {//模板生成函数
                    if (typeof colValue == 'undefined') {
                        colValue = null; //
                    }
                    try {
                        let colConf = this.usedColMap[colName] || null;
                        cellTpl = renderFunc(row, colName, colValue, rowIndex, colConf);
                    } catch (ex) {
                        console.error(ex);
                        //
                        cellTpl = colValue;
                    }

                }
                //
                if (cellTpl == null) {
                    cellTpl = ''
                } else {
                    cellTpl += '';
                }
                return cellTpl;
            },
            handleClickRowInner(row) {//提取出来解决列表刷新后第一次点击上次点中的行无效的问题
                if (!this.multiSelect) {
                    if (!this.isRowSelectable(row)) {
                        return;
                    }
                    let singleChanged = this.curSelection != row;
                    this.curSelection = row;
                    if (singleChanged && this.selChangeHandler != null) {
                        this.selChangeHandler.call(null, false, 1);
                    }
                }
            },
            handleClickRow(row, oldRow) {
                this.handleClickRowInner(row);
                //标记变量 给下个 row-click 事件提示（不要再处理了）
                this.current_change_event_handled = true;
            },
            handleClickRow1st(row) {
                if (!this.current_change_event_handled) {
                    this.handleClickRowInner(row);
                }
                this.current_change_event_handled = false;
            },
            //
            handleDblClickRow(row) {
                if (this.multiSelect) {
                    if (this.isRowSelectable(row)) {
                        this.theElTable.toggleRowSelection(row);
                    }
                } else {
                    if (!this.isRowSelectable(row)) {
                        return;
                    }
                    let singleChanged = this.curSelection != row;
                    this.curSelection = row;
                    //
                    if (this.rowDblClickHandler != null) {
                        this.rowDblClickHandler.call(null, Utils.merge(row));
                    } else if (singleChanged && this.selChangeHandler != null) {
                        this.selChangeHandler.call(null, false, 2);
                    }
                }
            },
            //恢复选择
            restoreSelection() {
                this.ignoreSelectionChange = true; //恢复中
                //
                let dataRows = this.dataRows;
                if (this.multiPageSelect) {
                    let curSelection = [];
                    let targetRows = findAndUpdateSelection(this.mulSelectionMap, this.dataRows, this.rowKeyPropName);
                    for (let i = 0, c = dataRows.length; i < c; i++) {
                        let row = dataRows[i];
                        let targetIndex = targetRows.indexOf(row);
                        if (targetIndex == -1) {
                            this.theElTable.toggleRowSelection(row, false);
                        } else {
                            targetRows.removeAt(targetIndex);
                            curSelection.push(row);
                            this.theElTable.toggleRowSelection(row, true);
                        }
                    }
                    this.curSelection = curSelection;
                } else {
                    if (this.multiSelect) {
                        let curSelection = this.curSelection || [];
                        let targetVals = curSelection.pluck(this.rowKeyPropName);
                        curSelection = [];
                        for (let i = 0, c = dataRows.length; i < c; i++) {
                            let row = dataRows[i];
                            let keyVal = row[this.rowKeyPropName];
                            let targetIndex = targetVals.indexOf(keyVal);
                            if (targetIndex != -1) {
                                targetVals.removeAt(targetIndex);
                                curSelection.push(row);
                                this.theElTable.toggleRowSelection(row, true);
                            }
                        }
                        this.curSelection = curSelection;
                    } else {
                        let curSelection = this.curSelection || null;
                        if (curSelection != null) {
                            let targetVal = curSelection[this.rowKeyPropName];
                            curSelection = null;
                            for (let i = 0, c = dataRows.length; i < c; i++) {
                                let row = dataRows[i];
                                let keyVal = row[this.rowKeyPropName];
                                if (targetVal == keyVal) {
                                    curSelection = row;
                                    this.theElTable.toggleRowSelection(row, true);
                                    break;
                                }
                            }
                        }
                        this.curSelection = curSelection;
                    }
                }
                //恢复完毕
                this.$nextTick(() => this.ignoreSelectionChange = false);
            },
            handleSelectionChg(selection) {
                if (!this.ignoreSelectionChange) {
                    if (!this.isRowSelectable(selection)) {
                        return;
                    }
                    //console.debug(selection);
                    this.curSelection = selection;
                    //
                    if (this.multiPageSelect) {
                        mergeSelection(this.mulSelectionMap, this.dataRows, this.curSelection, this.rowKeyPropName);
                    }
                    //
                    if (this.selChangeHandler != null) {
                        this.selChangeHandler.call(null, this.multiSelect, 0);
                    }
                }
            },
            handleColWidthChg(newWidth, oldWidth, column, event) {
                //console.debug(column);
                let colName = column.property;
                let colWidth = newWidth;
                //console.debug("[" + colName + "] width : " + oldWidth + " => " + newWidth);
                let liveColList = this.liveColList;
                let colIndex = liveColList.indexOf(colName, function (colConf) {
                    return colConf.name == colName;
                });
                let colConf = liveColList[colIndex];
                if (colConf != null) {
                    colConf.width = colWidth;
                    this.$set(liveColList, colIndex, colConf);
                    //
                    if (this.colWidthChangeHandler != null) {
                        this.colWidthChangeHandler.call(null, colName, colWidth);
                    }
                }
                //fix 表格固定列的行高错乱问题
                this.$nextTick(() => this.theElTable.doLayout());
            },
            //分页处理
            triggerPageEvent() {
                if (this.needPager) {
                    if (this.pageNoChangeHandler != null) {
                        this.pageNoChangeHandler.call(null, this.pageNumber, this.pageSize);
                    } else {
                        console.debug('分页 => 第【' + this.pageNumber + '】页，大小：' + this.pageSize);
                    }
                }
            },
            handlePageNoChange: function (val) {
                this.ignoreSelectionChange = true;
                //console.group('handlePageNoChange');
                this.pageNumber = val;
                //console.debug('pageNumber : ' + this.pageNumber);
                //console.debug('pageSize : ' + this.pageSize);
                //console.groupEnd();
                this.pageEventDelayer.delay(() => this.triggerPageEvent(), 200);
            },
            handlePageSizeChange: function (val) {
                //console.group('handlePageSizeChange');
                this.pageSize = val;
                //console.debug('pageSize : ' + this.pageSize);
                //console.debug('pageNumber : ' + this.pageNumber);
                //console.groupEnd();
                this.pageEventDelayer.delay(() => this.triggerPageEvent(), 200);
            },
            //====================================公开方法============================================
            //设置关联的QuerySortArea.vue 实例对象的引用
            setQrySortRef(qrySortRef = null) {
                if (qrySortRef == null) {
                    this.qrySortRef = null;
                } else {
                    let classInfo = Vue.$getClassInfo(qrySortRef);
                    if (classInfo == null || classInfo.custTag != 'QuerySortArea') {
                        console.error('设置的对象非法（必须是 QuerySortArea.vue 实例对象的引用）');
                        return;
                    }
                    this.qrySortRef = qrySortRef;
                }
            },
            //报表专用：链接函数所需
            setReportCode(reportCode) {
                this.reportCode = reportCode || null;
            },
            //报表专用: 链接函数调用上下文this对象
            setLinkFuncContext(linkFuncContext) {
                this.linkFuncContext = linkFuncContext;
            },
            //初始信息（单元格模板生成函数，单元格按钮点击处理函数）
            initMeta(renderFuncs = null, handlerFuncs = null) {
                if (renderFuncs != null) {
                    this.renderFuncs = renderFuncs;
                }
                if (handlerFuncs != null) {
                    this.handlerFuncs = handlerFuncs;
                }
                this.btnColTplItemsMap = {};
                //
                this.render([], null, true);
            },
            //清除当前选中的行
            clearSelection() {
                //清除选择
                if (this.mountedFlag) {
                    this.theElTable.clearSelection();
                }
                this.curSelection = this.multiSelect ? [] : null;
                //清除多页选择
                this.mulSelectionMap = {};
            },
            //设置初始选中项（对象或关键列的值[]）及 是否禁止初始项的选择
            setInitChecked(initChecked, disableInitCheckedSelection = false) {
                this.initCheckedDisabled = disableInitCheckedSelection === true;
                //
                let initCheckedSet = {};
                let rowKeyPropName = this.rowKeyPropName;
                if (this.multiSelect) {
                    if (initChecked == null || !Utils.isArray(initChecked)) {
                        initChecked = [];
                    }
                    //
                    if (this.initCheckedDisabled && initChecked.length > 0) {
                        initChecked.forEach(function (item) {
                            let keyVal = item;
                            if (Utils.isPlainObject(item)) {
                                keyVal = item[rowKeyPropName];
                            }
                            initCheckedSet[keyVal + ''] = true;
                        });
                        //
                        console.debug('--- 多选禁止选择的行[' + rowKeyPropName + '] ---');
                        console.debug(initCheckedSet);
                    }
                } else {
                    if (initChecked == null) {
                        initChecked = null;
                    }
                }
                this.initCheckedSet = initCheckedSet;
                this.initChecked = initChecked;
            },
            //指定要禁止选择的行（回调函数 rowDisabler(row) ：返回是否要禁用）
            setRowDisabler(rowDisabler) {
                if (typeof rowDisabler === 'function') {
                    this.rowDisabler = rowDisabler;
                } else {
                    this.rowDisabler = null;
                }
            },
            //渲染结果数据（注意：最后一个参数内部调用专用）
            //如果调用了setQrySortRef，则无需提供sortItemList参数
            render(tableData = null, sortItemList = null, keepInitChecked = false) {
                let qrySortRef = this.qrySortRef;
                //查询条件信息
                let curQryItems = [];
                if (qrySortRef != null) {
                    curQryItems = qrySortRef.getFormItems();
                }
                this.curQryItems = curQryItems;
                //查询排序信息
                if (sortItemList == null && qrySortRef != null) {
                    //主动从qrySortRef获取排序列信息
                    sortItemList = qrySortRef.getSortItemList();
                }
                sortItemList = sortItemList || [];
                //要展示的排序项
                let sortItemMap = {};
                let sortItemTexts = [];
                let fullColMap = this.fullColMap;
                for (let i = 0, c = sortItemList.length; i < c; i++) {
                    let sortItem = sortItemList[i];
                    let sortPair = sortItem.split(':');//name:desc
                    let name = sortPair[0];
                    let order = sortPair[1];
                    sortItemMap[name] = {
                        order: order,
                        seqNo: (i + 1)
                    };
                    //
                    let tempCol = fullColMap[name];
                    if (tempCol != null) {
                        sortItemTexts.push((tempCol.title || tempCol.text) + (order == 'desc' ? '↓' : '↑'));
                    }
                }
                this.sortItemMap = sortItemMap;
                if (sortItemTexts.length > 0) {
                    //把排序信息作为导出条件的“排序条件”
                    this.curQryItems.push({
                        'label': '排序条件',
                        'value': sortItemTexts.join('、')
                    });
                }
                //
                this.sortItemChanged = isColSortUpdated(this.sortItemList, sortItemList);
                //
                this.sortItemList = sortItemList;
                //
                this.init();
                //处理初始选择项
                if (this.multiPageSelect) {
                    if (this.initChecked != null) {//初始选择回显
                        let checkedItems = this.initChecked;
                        this.initChecked = null;//用完就重置（使用mulSelectionMap）
                        let mulSelectionMap = {};
                        for (let i = 0, c = checkedItems.length; i < c; i++) {
                            let tmpItem = checkedItems[i];
                            if (Utils.isPlainObject(tmpItem)) {//给的Object
                                let keyVal = tmpItem[this.rowKeyPropName];
                                mulSelectionMap[keyVal + ''] = tmpItem;
                            } else {//给的key值
                                let keyVal = tmpItem;
                                tmpItem = {};
                                tmpItem[this.rowKeyPropName] = keyVal;
                                mulSelectionMap[keyVal + ''] = tmpItem;
                            }
                        }
                        this.mulSelectionMap = mulSelectionMap;
                    }
                } else {
                    this.clearSelection();
                    //
                    if (this.multiSelect) {
                        if (this.initChecked != null) {//初始选择回显
                            let checkedItems = this.initChecked;
                            if (!keepInitChecked) {
                                this.initChecked = null;//用完重置
                            }
                            let selection = [];
                            for (let i = 0, c = checkedItems.length; i < c; i++) {
                                let tmpItem = checkedItems[i];
                                if (Utils.isPlainObject(tmpItem)) {//给的Object
                                    selection.push(tmpItem);
                                } else {//给的key值
                                    let keyVal = tmpItem;
                                    tmpItem = {};
                                    tmpItem[this.rowKeyPropName] = keyVal;
                                    selection.push(tmpItem);
                                }
                            }
                            this.curSelection = selection;
                        }
                    } else {
                        if (this.initChecked != null) {//初始选择回显
                            let checkedItem = this.initChecked;
                            if (!keepInitChecked) {
                                this.initChecked = null;//用完重置
                            }
                            let selection = null;
                            if (Utils.isPlainObject(checkedItem)) {//给的Object
                                selection = checkedItem;
                            } else {//给的key值
                                let keyVal = checkedItem;
                                checkedItem = {};
                                checkedItem[this.rowKeyPropName] = keyVal;
                                selection = checkedItem;
                            }
                            this.curSelection = selection;
                        }
                    }
                }
                //
                if (tableData == null) {
                    tableData = {
                        pagination: {
                            totalCount: 0,
                            pageNumber: 1
                        },
                        rows: []
                    };
                } else if (Utils.isArray(tableData)) {
                    let dataRows = tableData;
                    tableData = {
                        rows: dataRows
                    };
                }
                //{ rows, pagination }
                if (this.needPager && tableData.pagination == null) {
                    if (typeof tableData.total == 'number') {
                        //兼容 { total, rows, cols } 模型
                        let totalCount = tableData.total;
                        delete tableData['total'];
                        tableData.pagination = {
                            totalCount: totalCount,
                            pageNumber: this.pageNumber
                        }
                    } else {
                        let dataRows = tableData.rows || [];
                        let realRowCount = dataRows.length;
                        if (realRowCount > this.pageSize) {//多出一页
                            let pageInfo = {
                                pageSize: this.pageSize,
                                pageNumber: this.pageNumber
                            };
                            let mockData = Utils.toPaginatedData(dataRows, pageInfo);
                            let pagination = mockData.pagination;
                            dataRows = mockData.rows;
                            tableData = {
                                pagination: {//保留当前分页信息
                                    totalCount: realRowCount,
                                    pageNumber: pagination.pageNumber
                                },
                                rows: dataRows
                            };
                        } else {
                            tableData = {
                                pagination: {//保留当前分页信息
                                    totalCount: realRowCount,
                                    pageNumber: this.pageNumber
                                },
                                rows: dataRows
                            };
                        }
                    }
                }
                //
                if (Utils.isArray(tableData['cols'])) {//兼容 {cols, rows模型}
                    let cols = tableData['cols'];
                    delete tableData['cols']; //防止反弹
                    //
                    this.metaColList = cols;
                    this.liveColList = [];
                    this.init();
                }
                //分页信息 1
                let pagination = tableData['pagination'] || null;
                if (pagination != null) {
                    this.pageNumber = pagination.pageNumber > 0 ? pagination.pageNumber : 1;
                    this.totalCount = pagination.totalCount;
                }
                //列表数据 2
                this.dataRows = tableData['rows'] || [];
                //
                this.$nextTick(function () {
                    //恢复选择
                    this.restoreSelection();
                    //fix 表格固定列的行高错乱问题
                    this.$nextTick(() => this.theElTable.doLayout());
                });
            },
            //获取当前选中的行（单选：对象， 多选：数组[默认不包含禁选的初始行]）
            getSelection(includeDisabledInitChecked = false) {
                if (this.multiPageSelect) {
                    let selection = [];
                    let mulSelectionMap = this.mulSelectionMap;
                    //
                    let initCheckedDisabled = this.initCheckedDisabled;
                    let initCheckedSet = this.initCheckedSet;
                    for (let val in mulSelectionMap) {
                        let valKey = val + '';
                        if (!includeDisabledInitChecked && initCheckedDisabled && initCheckedSet[valKey]) {
                            //console.log('disabled :' + valKey);
                            continue;
                        }
                        selection.push(Utils.merge(mulSelectionMap[valKey]));
                    }
                    return selection;
                } else {
                    if (this.multiSelect) {
                        let selection = [];
                        let curSelection = this.curSelection || [];
                        //
                        let tmpRow = null;
                        let rowKeyPropName = this.rowKeyPropName;
                        let initCheckedDisabled = this.initCheckedDisabled;
                        let initCheckedSet = this.initCheckedSet;
                        for (let i = 0, c = curSelection.length; i < c; i++) {
                            tmpRow = curSelection[i];
                            let valKey = tmpRow[rowKeyPropName] + '';
                            if (!includeDisabledInitChecked && initCheckedDisabled && initCheckedSet[valKey]) {
                                //console.log('disabled :' + valKey);
                                continue;
                            }
                            selection.push(Utils.merge(tmpRow));
                        }
                        return selection;
                    } else {
                        return this.curSelection == null ? null : Utils.merge(this.curSelection);
                    }
                }
            },
            //获取当前分页信息
            getPagination() {
                return {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                };
            },
            //清除数据信息（可选包含清除初始选择项信息）
            clear(includeInitChecked = false) {
                this.clearSelection();
                //
                if (includeInitChecked == true) {
                    this.initCheckedSet = {};
                }
                //清空列表数据
                this.dataRows = [];
                //重置分页信息
                this.pageNumber = 1;
                this.totalCount = 0;
            },
            //导出专用：是否使用导出的行号 及 导出的行号列名
            useExportRowNo(exportRowNo = true, exportRowNoColName = 'row_no', exportRowNoColTitle = '行号') {
                this.exportRowNo = exportRowNo || false;
                if (this.exportRowNo) {
                    if (exportRowNoColName) {
                        this.exportRowNoColName = exportRowNoColName;
                    }
                    if (exportRowNoColTitle) {
                        this.exportRowNoColTitle = exportRowNoColTitle;
                    }
                }
            },
            //导出专用：获取当前显示的列信息
            getUsedColList(ignoreGroup = false /* 是否忽略列头的合并分组信息 */) {
                let usedColList = this.usedColList.map(function (col) {
                    let tempCol = {
                        name: col.name,
                        title: col.title || col.text,
                        dataType: col.dataType || null,
                        format: col.format || null,
                        enumMap: col.enumMap || null,
                        align: col.align || null,
                        width: col.width || null,
                        fixed: col.fixed || false,
                        enumMapObject: col.enumMapObject || null
                    };
                    if (!ignoreGroup) {
                        tempCol.group = col.group || null;
                    }
                    return tempCol;
                });
                if (this.exportRowNo && this.rowNoShow) {
                    usedColList.unshift({
                        name: this.exportRowNoColName,
                        title: this.exportRowNoColTitle,
                        dataType: 'integer',
                        align: 'right',
                        width: 60,
                        fixed: this.rowNoFixedX
                    });
                }
                return usedColList;
            },

            //导出专用：获取当前显示的数据列+行信息{cols, rows[, pageNumber, pageSize, pageCount]}
            getTableData(includeCols = false /* 是否包含当前显示的列信息 */, ignoreGroup = false /* 是否忽略列头的合并分组信息 */) {//
                let retData = {};
                //
                let usedColList = this.getUsedColList(ignoreGroup);
                if (includeCols) {
                    retData.cols = usedColList;//cols
                }
                let usedColNames = usedColList.pluck('name');
                let usedColCount = usedColNames.length;
                let colName = null;
                let tmpVal = null;
                let usedRowList = this.dataRows.map(function (row) {
                    let usedRow = {};
                    for (let i = 0; i < usedColCount; i++) {
                        colName = usedColNames[i];
                        tmpVal = row[colName];
                        if (tmpVal == null) {
                            tmpVal = null;//防止undefined
                        }
                        usedRow[colName] = tmpVal;
                    }
                    return usedRow;
                });
                if (this.exportRowNo && this.rowNoShow) {
                    let usedRow = null;
                    let exportRowNoColName = this.exportRowNoColName;
                    for (let i = 0, c = usedRowList.length; i < c; i++) {
                        usedRow = usedRowList[i];
                        usedRow[exportRowNoColName] = this.getRowNo(i);
                    }
                }
                retData.rows = usedRowList;//rows
                if (this.needPager) {//pageNo
                    retData.pageNumber = this.pageNumber;
                    retData.pageSize = this.pageSize;
                    //
                    retData.pageCount = Math.ceil(this.totalCount / this.pageSize);
                }
                //
                if (this.curQryItems.length > 0) {
                    retData.qryItems = Utils.merge([], this.curQryItems);
                }
                //
                return retData;
            },
            getLiveConfig() {
                let colList = Utils.merge(this.liveColList);
                return {
                    colList: colList
                };
            },
            //forHisQry 专用：获取当前显示的数据列 {resultCols, pageNumber, pageSize]}
            getResultInfo(ignoreGroup = false /* 是否忽略列头的合并分组信息 */) {
                let retData = {};
                //
                let allCols = this.liveColList || [];
                let resultCols = [];
                let tmpCol = null;
                for (let i = 0, c = allCols.length; i < c; i++) {
                    tmpCol = allCols[i];
                    if (tmpCol.virtualFlag) {
                        //忽略虚拟列
                        continue;
                    }
                    resultCols.push({
                        colName: tmpCol.name,
                        label: tmpCol.title || tmpCol.text,
                        dataType: tmpCol.dataType,
                        format: tmpCol.format || null,
                        enumMap: tmpCol.enumMap || null
                    });
                }
                retData.resultCols = resultCols;
                //
                if (this.needPager) {//pageNo
                    retData.pageNumber = this.pageNumber;
                    retData.pageSize = this.pageSize;
                }
                //
                return retData;
            }
        }
    }

</script>
<style>
    .result-table-wrapper {
        width: 100%;
        overflow-y: hidden;
    }

    .result-table .el-table__header .col-title-tooltip-wrapper {
        float: right;
        height: 100%;
        margin-right: -2px;
    }

    .result-table .el-table__header .col-title-tooltip {
        margin: auto 0;
    }

    .result-table.el-table .el-table__header .caret-wrapper.mark-only {
        cursor: default;
        height: 20px;
    }

    .result-table.el-table .el-table__header .ascending .sort-caret.ascending {
        top: -1px;
    }

    .result-table.el-table .el-table__header .ascending .sort-caret.descending {
        bottom: 1px;
    }

    .result-table.el-table .el-table__header .descending .sort-caret.ascending {
        top: -2px;
    }

    .result-table.el-table .el-table__header .descending .sort-caret.descending {
        bottom: 2px;
    }

    .result-table.el-table .el-table__body tr.selected > td {
        background-color: #FFEFE5 !important;
        color: #333;
    }

    .result-table.el-table .el-table__body tr.selected.unselectable > td, .result-table.el-table .el-table__body tr.unselectable > td {
        background-color: #F0FAFA !important;
        color: #AAA;
        position: relative;
        cursor: not-allowed;
    }

    .result-table.el-table .el-table__body tr > td .action-img {
        width: 46px;
        height: 14px;
        vertical-align: middle;
        cursor: pointer;
    }

    .result-table.el-table .el-table__body tr > td .action-btn.disabled .action-img {
        cursor: default;
        opacity: 0.3;
    }

    .result-table.el-table .el-table__body tr > td .action-btn.disabled {
        background-color: #EEEEEE;
        color: #9999;
        border-color: #CCCCCC;
        cursor: default;
    }

    .result-table.el-table.single-sel .el-table__body tr.selected > td:first-child:before {
        content: '√';
        color: #2D8CF0;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto 0;
        width: 22px;
        height: 22px;
        font-size: 16px;
        font-weight: bold;

    }

    .pagination-wrapper .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fff;
        color: #0c64eb;
        border: 1px solid #0c64eb;
    }

    .pagination-wrapper .el-pagination.is-background .el-pager li {
        background-color: #fff;
    }

    .pagination-wrapper .el-pagination .el-pagination__total {
        float: left;
    }

    .pagination-wrapper .el-pagination .el-pagination__sizes {
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/compo/query/ResultTable.vue